import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import HotRecommendSection from './components/HotRecommendSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://qiezi.video/#organization",
      "name": "茄子视频",
      "url": "https://qiezi.video/",
      "description": "茄子视频提供高清免费在线观看，不缓冲流畅播放电视剧全集、电影大全",
      "sameAs": [
        "https://qiezi.video/"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://qiezi.video/#website",
      "url": "https://qiezi.video/",
      "name": "茄子视频",
      "description": "茄子视频 - 高清免费在线观看平台",
      "inLanguage": "zh-CN",
      "publisher": { "@id": "https://qiezi.video/#organization" }
    },
    {
      "@type": "WebPage",
      "@id": "https://qiezi.video/#webpage",
      "url": "https://qiezi.video/",
      "name": "茄子视频 - 高清免费在线观看电视剧全集",
      "description": "茄子视频提供高清免费在线观看，不缓冲流畅播放电视剧全集、电影大全",
      "inLanguage": "zh-CN",
      "isPartOf": { "@id": "https://qiezi.video/#website" },
      "about": { "@id": "https://qiezi.video/#organization" }
    }
  ]
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <HotRecommendSection />
        <CategorySection />
        <ArticleSection />
        <FAQSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
    </>
  );
}